import { Delete, Post } from "./common";

export default class DisputeService {
  static create = async (token: string, data: any) =>
    await Post({ path: "disputes", token, body: data });

  static getMine = async (token: string, data: any) =>
    await Post({ path: "disputes/mine", token, body: data });

  static hasActive = async (token: string, data: any) =>
    await Post({ path: "disputes/has-active", token, body: data });

  static deleteById = async (id: string, token: string) =>
    await Delete({ path: `disputes/${id}`, token });
}
